var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-row",
    { staticClass: "p-3 mt-2 shadow-sm bg-white" },
    [
      _c(
        "vs-col",
        { attrs: { "vs-lg": "11" } },
        [
          _c(
            "vs-row",
            { attrs: { "vs-type": "flex", "vs-align": "center" } },
            [
              _c(
                "vs-col",
                { staticClass: "text-primary", attrs: { "vs-lg": "6" } },
                [
                  _c(
                    "div",
                    { staticClass: "d-flex align-items-center" },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "mr-2",
                        class: _vm.fileTypeIcon({ name: _vm.doc.DOCNAME }),
                        staticStyle: { "font-size": "20px" },
                        attrs: {
                          icon: [
                            "fas",
                            _vm.fileTypeIcon({ name: _vm.doc.DOCNAME })
                          ]
                        }
                      }),
                      _c("div", [
                        _c("span", [_vm._v(_vm._s(_vm.doc.DOCNAME))]),
                        _c("small", { staticClass: "d-block" }, [
                          _vm._v(_vm._s(_vm.displayTypeDesc))
                        ])
                      ])
                    ],
                    1
                  )
                ]
              ),
              _c(
                "vs-col",
                { staticClass: "text-primary", attrs: { "vs-lg": "5" } },
                [_vm._v(" " + _vm._s(_vm.displayAuthor) + " ")]
              )
            ],
            1
          ),
          _c(
            "vs-row",
            [
              _c(
                "vs-col",
                {
                  staticClass: "pt-2 border-top chips-row",
                  attrs: { "vs-lg": "12", "vs-type": "flex" }
                },
                [
                  _vm.displayFolio
                    ? _c(
                        "vs-chip",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Folio: " + _vm.displayFolio,
                              expression: "'Folio: ' + displayFolio"
                            }
                          ],
                          staticClass: "mr-2 mb-1 folio-chip",
                          nativeOn: {
                            dblclick: function($event) {
                              return _vm.copyFolio($event)
                            }
                          }
                        },
                        [
                          _c("vs-avatar", {
                            attrs: { icon: "tag", color: "#ff9f43" }
                          }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.truncate(_vm.displayFolio, 40)) +
                              " "
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.doc.DOCUMENTO_MADRE
                    ? _c(
                        "vs-chip",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value:
                                "Documento Madre: " + _vm.doc.DOCUMENTO_MADRE,
                              expression:
                                "'Documento Madre: ' + doc.DOCUMENTO_MADRE"
                            }
                          ],
                          staticClass: "mr-2 mb-1"
                        },
                        [
                          _c("vs-avatar", {
                            attrs: {
                              icon: "supervisor_account",
                              color: "#8633FF"
                            }
                          }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.truncate(_vm.doc.DOCUMENTO_MADRE, 14)
                              ) +
                              " "
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.displayFechaDocumento
                    ? _c(
                        "vs-chip",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Fecha de documento",
                              expression: "'Fecha de documento'"
                            }
                          ],
                          staticClass: "mr-2 mb-1"
                        },
                        [
                          _c("vs-avatar", { attrs: { icon: "date_range" } }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("dateFormat")(_vm.displayFechaDocumento)
                              ) +
                              " "
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "vs-chip",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Fecha de creacion",
                          expression: "'Fecha de creacion'"
                        }
                      ],
                      staticClass: "mr-2 mb-1"
                    },
                    [
                      _c("vs-avatar", { attrs: { icon: "date_range" } }),
                      _vm._v(
                        " " +
                          _vm._s(_vm._f("dateFormat")(_vm.doc.CREATION_DATE)) +
                          " "
                      )
                    ],
                    1
                  ),
                  _vm.doc.LAST_EDIT_DATE
                    ? _c(
                        "vs-chip",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Fecha de actualización",
                              expression: "'Fecha de actualización'"
                            }
                          ],
                          staticClass: "mr-4"
                        },
                        [
                          _c("vs-avatar", { attrs: { icon: "date_range" } }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("dateFormat")(_vm.doc.LAST_EDIT_DATE)
                              ) +
                              " "
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.displayIdAutor
                    ? _c(
                        "vs-chip",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Autor",
                              expression: "'Autor'"
                            }
                          ],
                          staticClass: "mr-2 mb-1"
                        },
                        [
                          _c("vs-avatar", {
                            attrs: { icon: "business", color: "#FF0000" }
                          }),
                          _vm._v(" " + _vm._s(_vm.displayIdAutor) + " ")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.displayEmpresa
                    ? _c(
                        "vs-chip",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Empresa",
                              expression: "'Empresa'"
                            }
                          ],
                          staticClass: "mr-2 mb-1"
                        },
                        [
                          _c("vs-avatar", {
                            attrs: { icon: "business", color: "#003287" }
                          }),
                          _vm._v(" " + _vm._s(_vm.displayEmpresa) + " ")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.displayTema
                    ? _c(
                        "vs-chip",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Tema",
                              expression: "'Tema'"
                            }
                          ],
                          staticClass: "mr-2 mb-1"
                        },
                        [
                          _c("vs-avatar", {
                            attrs: { icon: "label", color: "#7367f0" }
                          }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.truncate(_vm.displayTema, 16)) +
                              " "
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.doc.ID_SUBTEMA
                    ? _c(
                        "vs-chip",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Subtema",
                              expression: "'Subtema'"
                            }
                          ],
                          staticClass: "mr-2 mb-1"
                        },
                        [
                          _c("vs-avatar", {
                            attrs: { icon: "edit", color: "#ff9f43" }
                          }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.truncate(_vm.doc.ID_SUBTEMA, 16)) +
                              " "
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.doc.MATERIA_REG
                    ? _c(
                        "vs-chip",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Materia: " + _vm.doc.MATERIA_REG,
                              expression: "'Materia: ' + doc.MATERIA_REG"
                            }
                          ],
                          staticClass: "mr-2 mb-1"
                        },
                        [
                          _c("vs-avatar", {
                            attrs: { icon: "subject", color: "#00cfe8" }
                          }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.truncate(_vm.doc.MATERIA_REG, 20)) +
                              " "
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "vs-chip",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Tiene documento adjunto",
                          expression: "'Tiene documento adjunto'"
                        }
                      ],
                      staticClass: "mr-2 mb-1",
                      attrs: { color: "success" }
                    },
                    [
                      _c("vs-avatar", {
                        attrs: { icon: "description", color: "success" }
                      }),
                      !_vm.hasAdjunto
                        ? _c("span", [_vm._v("sin adjunto")])
                        : _c("span", [_vm._v("con adjunto")])
                    ],
                    1
                  ),
                  _vm.displayTipoDocumento
                    ? _c(
                        "vs-chip",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Tipo de documento",
                              expression: "'Tipo de documento'"
                            }
                          ],
                          staticClass: "mr-2 mb-1",
                          attrs: { color: "success" }
                        },
                        [
                          _c("vs-avatar", {
                            attrs: {
                              icon: "insert_drive_file",
                              color: "success"
                            }
                          }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.truncate(_vm.displayTipoDocumento, 12)
                              ) +
                              " "
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isEgestion && _vm.displayFileName
                    ? _c(
                        "vs-chip",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Nombre archivo: " + _vm.displayFileName,
                              expression: "'Nombre archivo: ' + displayFileName"
                            }
                          ],
                          staticClass: "mr-2 mb-1"
                        },
                        [
                          _c("vs-avatar", {
                            attrs: { icon: "attach_file", color: "#5b3cc4" }
                          }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.truncate(_vm.displayFileName, 24)) +
                              " "
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isEgestion && _vm.doc.UNITY
                    ? _c(
                        "vs-chip",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Unidad: " + _vm.doc.UNITY,
                              expression: "'Unidad: ' + doc.UNITY"
                            }
                          ],
                          staticClass: "mr-2 mb-1"
                        },
                        [
                          _c("vs-avatar", {
                            attrs: { icon: "apartment", color: "#0277bd" }
                          }),
                          _vm._v(
                            " " + _vm._s(_vm.truncate(_vm.doc.UNITY, 16)) + " "
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isEgestion && _vm.doc.SIZE
                    ? _c(
                        "vs-chip",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Tamano",
                              expression: "'Tamano'"
                            }
                          ],
                          staticClass: "mr-2 mb-1"
                        },
                        [
                          _c("vs-avatar", {
                            attrs: { icon: "save", color: "#777" }
                          }),
                          _vm._v(" " + _vm._s(_vm.displayFileSize) + " ")
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("vs-col", { attrs: { "vs-lg": "1" } }, [
        _vm.doc.DOCNUM
          ? _c(
              "div",
              {
                staticClass: "action",
                on: {
                  click: function($event) {
                    return _vm.$emit("download", _vm.doc.DOCNUM)
                  }
                }
              },
              [
                _c("font-awesome-icon", {
                  staticClass: "action-icon",
                  attrs: { icon: ["fas", "download"] }
                })
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }